module.exports = __webpack_public_path__ + "static/img/bb4.0c69e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bb4.png
// module id = rip6
// module chunks = 1